import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "v-field-label-l"
};
const _hoisted_2 = {
  class: "field-label-txt"
};
const _hoisted_3 = {
  key: 1,
  class: "v-field-label-r"
};
const _hoisted_4 = {
  class: "field-label-txt"
};
const _hoisted_5 = {
  key: 2,
  class: "v-field-label-c"
};
const _hoisted_6 = {
  class: "field-label-txt"
};
const _hoisted_7 = {
  class: "v-field-label-container"
};
import { toRefs } from 'vue';
const __default__ = {
  name: 'FieldLabel'
};
export default /*@__PURE__*/Object.assign(__default__, {
  props: {
    label: {
      type: String,
      default: '标题'
    },
    labelAlign: {
      type: String,
      default: 'right'
    },
    colon: {
      type: Boolean,
      default: true
    },
    labelCol: {
      type: Object,
      default: () => ({
        style: 'width: 80px'
      })
    }
  },
  setup(__props) {
    const props = __props;
    const {
      label,
      labelCol,
      labelAlign,
      colon
    } = toRefs(props);
    return (_ctx, _cache) => {
      const _component_a_col = _resolveComponent("a-col");
      const _component_a_row = _resolveComponent("a-row");
      return _openBlock(), _createElementBlock("div", _mergeProps({
        class: "ui-field-label"
      }, _ctx.$attrs), [_unref(labelAlign) === 'left' || _unref(labelAlign) === 'right' ? (_openBlock(), _createBlock(_component_a_row, _mergeProps({
        key: 0,
        gutter: 16,
        justify: "end",
        align: "middle"
      }, _ctx.$attrs), {
        default: _withCtx(() => [_createVNode(_component_a_col, _normalizeProps(_guardReactiveProps(_unref(labelCol))), {
          default: _withCtx(() => [_createElementVNode("span", {
            class: _normalizeClass({
              'field-label-txt': true,
              colon: _unref(colon)
            })
          }, [_renderSlot(_ctx.$slots, "label", {}, () => [_createTextVNode(_toDisplayString(_unref(label)), 1)])], 2)]),
          _: 3
        }, 16), _createVNode(_component_a_col, {
          flex: 1
        }, {
          default: _withCtx(() => [_renderSlot(_ctx.$slots, "default")]),
          _: 3
        })]),
        _: 3
      }, 16)) : (_openBlock(), _createElementBlock("div", _mergeProps({
        key: 1
      }, _ctx.$attrs, {
        class: "v-field-label"
      }), [_unref(labelAlign) === 'topLeft' ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", _hoisted_2, _toDisplayString(_unref(label)), 1)])) : _createCommentVNode("", true), _unref(labelAlign) === 'topRight' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, _toDisplayString(_unref(label)), 1)])) : _createCommentVNode("", true), _unref(labelAlign) === 'topCenter' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, _toDisplayString(_unref(label)), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, [_renderSlot(_ctx.$slots, "default")])], 16))], 16);
    };
  }
});